import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzShowUploadList, NzUploadFile } from 'ng-zorro-antd/upload';
import { MinioControllerService } from 'src/app/sdk/services/minio-controller.service';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { BASE_DATA_ITEMS, EDICT_DATA_FORM } from '../../constant/base-data';
import { DetailApplicationService } from '../../service/detail-application.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-base-data',
  templateUrl: './base-data.component.html',
  styleUrls: ['./base-data.component.scss']
})
export class BaseDataComponent implements OnInit {
  @Input() step: number;
  @Input() activeBtn: string;
  @Input() isEdit: boolean = false;
  @Input() isEditImage: boolean = false;
  @Input() DetailData;
  @Input() electromechanical = false;
  @Input() civilEngineering = false;
  @Input() activate = false;
  @Input() nzShowButton = false;
  @Input() nzShowUploadList: NzShowUploadList;
  @Output() submitDataEvent = new EventEmitter<object>();

  destroy$ = new Subject();
  listItem: {};
  userid: string;
  num: number;
  title: string;
  formItem = [...BASE_DATA_ITEMS];
  radioValue = '土建';
  expression = false;
  detailstatus = false;
  invoices = this.formItem.slice(0, 2);
  userMsg = this.formItem.slice(2, 4);
  siteMsg = this.formItem.slice(4, 10);

  nzListType = "picture-card";
  nzName = "file";
  imageList: NzUploadFile[] = [];
  fileList: NzUploadFile[] = [];
  imageArr = [];
  fileArr = []
  signData = {};

  nzShowUploadListOfImage: NzShowUploadList = {
    showRemoveIcon: false,
    showDownloadIcon: true,
    showPreviewIcon: true
  }

  edictData = { EDICT_DATA_FORM };
  constructor(
    private minioService: MinioControllerService,
    private detailApplicationService: DetailApplicationService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) {
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.DetailData['applayTime'] = this.commonService.switchDateLanguage(this.DetailData['applayTime']);
    });
  }

  ngOnInit(): void {
    // do something
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.DetailData) {
      this.getImagesOrFilesInit();
    }
    this.edictData['electromechanical'] = this.electromechanical.valueOf() ? 1 : 0;
    this.edictData['civilEngineering'] = this.civilEngineering.valueOf() ? 1 : 0;
    this.edictData['description'] = this.DetailData['description'];
    if (this.edictData['requireDocs'] !== undefined) {
      this.DetailData['requireDocs'] = JSON.stringify(this.edictData['requireDocs']);
    }
    this.DetailData['applayTime'] = this.commonService.switchDateLanguage(this.DetailData['applayTime']);
    this.submitDataEvent.emit(this.edictData);
  }


  async getImagesOrFilesInit() {
    this.imageList = [];
    this.fileList = [];
    this.imageArr = this.DetailData['image'].length !== 0 ?
      JSON.parse(this.DetailData['image']) : [];
    this.fileArr = this.DetailData['requireDocs'].length !== 0 ?
      JSON.parse(this.DetailData['requireDocs']) : [];
    let detailImageLsit = [];
    for (let i = 0; i < this.imageArr.length; i++) {
      let fileOrImage = await this.minioService.getFiletest({ url: this.imageArr[i] }).toPromise();
      let fileOrImageObject = JSON.parse(fileOrImage as any);
      let item: NzUploadFile = {
        uid: 'image' + i,
        name: this.imageArr[i].split('/')[3],
        status: 'done',
        url: fileOrImageObject['data'].replace("http://", "https://"),//为防止https调用http报不安全的错误导致无法正常下载
        thumbUrl: fileOrImageObject['data'].replace("http://", "https://"),
      }
      detailImageLsit.push(item);
    }
    let detailFileLsit = [];
    for (let i = 0; i < this.fileArr.length; i++) {
      let fileOrImage = await this.minioService.getFiletest({ url: this.fileArr[i] }).toPromise();
      let fileOrImageObject = JSON.parse(fileOrImage as any);
      let item: NzUploadFile = {
        uid: 'name' + i,
        name: this.fileArr[i].split('/')[3],
        status: 'done',
        url: fileOrImageObject['data'].replace("http://", "https://"),//为防止https调用http报不安全的错误导致无法正常下载
        thumbUrl: fileOrImageObject['data'].replace("http://", "https://"),
      }
      detailFileLsit.push(item);
    }
    this.imageList = detailImageLsit;
    this.fileList = detailFileLsit;
  }


  isUpload(event: NzUploadFile[], value: string) {
    this.edictData[value] = event;
    this.submitDataEvent.emit(this.edictData);
  }

  nzChanged(event: string, value: string) {
    if (value === "description") {
      this.edictData[value] = event;
    } else {
      this.edictData[value] = event ? 1 : 0;
    }
    this.submitDataEvent.emit(this.edictData);
    //
    this.detailApplicationService.civilOrElec.next(this.edictData);
  }
  checkBoxClick() {
    return false;
  }
}
